import { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import style from './style.module.scss'
import dynamic from 'next/dynamic'
import { Button } from 'react-bootstrap'

import { useLazyQuery } from '@apollo/client'
import { isBottomReached } from '@shared-submodule/utils'
import { liveArticleListLoader } from '@shared/libs/allLoader'
import { GET_LIVE_BLOGS } from '@shared-submodule/sm-graphql/live-blog/liveblog.query'
// import { GET_LIVE_BLOG_SUBSCRIPTION } from '@shared-submodule/sm-graphql/live-blog/liveblog.subscription'
// import EventMatchCard from '@shared/components/liveArticle/eventMatchCard'
const LiveBlogCard = dynamic(() => import('@shared/components/liveArticle/liveBlogCard'))
const EventMatchCard = dynamic(() => import('@shared/components/liveArticle/eventMatchCard'))

function LiveArticle({ setTimelineData, liveArticleList, liveArticleEvent, liveEventId, disableMatchCard, ...props }) {
  const [liveBlogData, setLiveBlogsData] = useState(liveArticleList)
  const [enableBtn, setEnableBtn] = useState(liveArticleList?.length >= 15)
  const btnDisabled = useRef(false)
  const loading = useRef(false)
  const lastItemEventId = useRef(liveArticleList?.[0] || '0')
  const lastData = useRef(0)
  const payloads = useRef({
    nLimit: 15,
    iEventId: liveEventId,
    sEventId: liveArticleList?.[liveArticleList?.length - 1]?.sEventId
  })

  function setLiveBlogs(data) {
    setLiveBlogsData(data)
    setTimelineData && setTimelineData(data)
  }

  const [getMoreLiveBlogs, { data: updatedLiveBlogs, loading: isContentLoading }] = useLazyQuery(GET_LIVE_BLOGS)

  // const operations = {
  //   delete: (data) => setLiveBlogs(liveBlogData.filter(lb => lb._id !== data?._id)),
  //   update: (data) => setLiveBlogs(liveBlogData.map(lb => lb._id === data?._id ? data : lb)),
  //   add: (data) => {
  //     setLiveBlogs(LiveBlogs => [data, ...LiveBlogs])
  //   }
  // }
  const [getLatestLiveBlogs] = useLazyQuery(GET_LIVE_BLOGS, {
    onCompleted: (data) => {
      const aResults = data?.listLiveBlogContentFront?.aResults
      if (aResults?.length) {
        setLiveBlogs(p => [...aResults, ...p])
      }
    }
  })
  useEffect(() => {
    const interval = setInterval(() => {
      getLatestLiveBlogs({ variables: { input: { iEventId: liveEventId, nLimit: 15, sEventId: lastItemEventId.current, bReverse: true } } })
    }, 10000)
    return () => {
      clearInterval(interval)
    }
  }, [])

  // typeof window !== 'undefined' && useSubscription(GET_LIVE_BLOG_SUBSCRIPTION, {
  //   variables: { input: { iEventId: liveEventId } },
  //   onSubscriptionData: ({ subscriptionData: { data } }) => {
  //     operations[data?.listLiveBlogContent?.eOpType || 'add'](data?.listLiveBlogContent?.liveBlogContent)
  //   }
  // })

  const handleLoadMore = () => {
    getMoreLiveBlogs({ variables: { input: { ...payloads.current } } })
    setEnableBtn(false)
    btnDisabled.current = true
  }

  useEffect(() => {
    if (liveBlogData?.length) {
      const lastItem = liveBlogData?.[liveBlogData?.length - 1]
      const id = `${lastItem?._id}_${lastItem?.iEventId}_${lastItem?.sEventId}`
      payloads.current.sEventId = lastItem?.sEventId
      lastItemEventId.current = liveBlogData[0]?.sEventId
      payloads.current.iEventId = lastItem?.iEventId
      if (btnDisabled.current) {
        loading.current = false
        isBottomReached(id, isReached)
      }
    }
  }, [liveBlogData])

  useEffect(() => {
    if (updatedLiveBlogs) {
      setLiveBlogs([...liveBlogData, ...updatedLiveBlogs?.listLiveBlogContentFront?.aResults])
      lastData.current = updatedLiveBlogs?.listLiveBlogContentFront?.aResults?.length
    }
  }, [updatedLiveBlogs])

  async function isReached(reach) {
    if (reach && !loading.current && lastData.current > 14) {
      loading.current = true
      getMoreLiveBlogs({ variables: { input: { ...payloads.current } } })
    }
  }

  return (
    <div {...props}>
      {!disableMatchCard ? <>
        {liveArticleEvent?.oMatch ? <EventMatchCard data={liveArticleEvent} liveEventId={liveEventId} /> : null}
      </> : null}
      {/* live article cards */}
      {
        liveBlogData?.length > 0 ? (<div className={`${style.liveMain} my-3`}>
          {liveBlogData.map((liveBlog) => <LiveBlogCard data={liveBlog} key={liveBlog._id} />)}
          {isContentLoading && liveArticleListLoader()}
        </div>) : <div className={style.noLiveArticles}>{'No Live Blogs Yet'}</div>
      }
      {
        enableBtn && <div className="text-center my-3">
          <Button className="theme-btn" onClick={handleLoadMore}>{'Load more'}</Button>
        </div>
      }
    </div >
  )
}

LiveArticle.propTypes = {
  liveArticleList: PropTypes.array,
  liveArticleEvent: PropTypes.object,
  liveEventId: PropTypes.string,
  setTimelineData: PropTypes.func,
  disableMatchCard: PropTypes.bool
}
export default LiveArticle
